module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("动态管理")]), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('el-form', {
    staticClass: "search-row",
    attrs: {
      "inline": true,
      "model": _vm.queryParam,
      "label-width": "82px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "动态ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "精确搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "精确搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.userId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userId", $$v)
      },
      expression: "queryParam.userId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "昵称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.nickName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickName", $$v)
      },
      expression: "queryParam.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "时间选择器"
    },
    model: {
      value: (_vm.queryParam.publishTimeStart),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "publishTimeStart", $$v)
      },
      expression: "queryParam.publishTimeStart"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "range-divider"
  }, [_vm._v("~")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "时间段"
    },
    model: {
      value: (_vm.queryParam.publishTimeEnd),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "publishTimeEnd", $$v)
      },
      expression: "queryParam.publishTimeEnd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否精选"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.queryParam.isHandpick),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isHandpick", $$v)
      },
      expression: "queryParam.isHandpick"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "是",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": 0
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否置顶"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.queryParam.isPinned),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isPinned", $$v)
      },
      expression: "queryParam.isPinned"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "是",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": 0
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号类型",
      "label-width": "82px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.queryParam.authorType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "authorType", $$v)
      },
      expression: "queryParam.authorType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "普通用户",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "马甲号",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "官方号",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "校园主理人",
      "value": 4
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跑步记录"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.queryParam.hasRunningRecord),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hasRunningRecord", $$v)
      },
      expression: "queryParam.hasRunningRecord"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "是",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": 0
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "search-action-item"
  }, [_c('el-button', {
    on: {
      "click": _vm.clickReset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickSearch
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "status-tabs"
  }, [_c('div', {
    staticClass: "status-tabs-row"
  }, [_c('div', {
    staticClass: "status-tab-group"
  }, _vm._l((_vm.statusTabs), function(item) {
    return _c('el-button', {
      key: item.value,
      class: [
        'status-tab-btn',
        {
          'is-active': _vm.currentStatus === item.value
        } ],
      on: {
        "click": function($event) {
          return _vm.changeStatus(item.value)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "add-dynamic-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goAddDynamic
    }
  }, [_vm._v("新增动态")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    ref: "dynamicTable",
    attrs: {
      "data": _vm.listData,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "动态ID",
      "min-width": "95",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userId",
      "label": "用户ID",
      "min-width": "95",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.routeDynamicDetail(row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(row.userId) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nickname",
      "label": "昵称",
      "min-width": "110",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorTypeText",
      "label": "类型",
      "min-width": "95",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "内容",
      "min-width": "220",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.content || "--"))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "图片数量/视频时长",
      "min-width": "168",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(!row.videoUrl && !(row.images && row.images.length)) ? _c('div', {
          staticClass: "media-info-cell media-info-cell--empty"
        }, [_vm._v("\n            --\n          ")]) : _c('div', {
          staticClass: "media-info-cell"
        }, [(row.videoUrl) ? _c('div', {
          staticClass: "media-thumb-wrap media-thumb--video",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.openVideoPreview(row)
            }
          }
        }, [(row.videoCover) ? _c('img', {
          staticClass: "media-thumb",
          attrs: {
            "src": row.videoCover,
            "alt": ""
          }
        }) : _c('div', {
          staticClass: "media-thumb media-thumb--fallback"
        }, [_vm._v("视频")]), _vm._v(" "), _c('span', {
          staticClass: "media-play-icon"
        }, [_c('i', {
          staticClass: "el-icon-caret-right"
        })])]) : (row.images && row.images.length) ? _c('div', {
          staticClass: "media-thumb-wrap",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.openImagePreview(row)
            }
          }
        }, [_c('img', {
          staticClass: "media-thumb",
          attrs: {
            "src": row.images[0],
            "alt": ""
          }
        }), _vm._v(" "), (row.images.length > 1) ? _c('span', {
          staticClass: "media-thumb-badge"
        }, [_vm._v(_vm._s(row.images.length) + "张")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "media-info-value"
        }, [_vm._v(_vm._s(row.mediaInfoDisplay))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "topicNames",
      "label": "关联话题",
      "min-width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跑步记录",
      "min-width": "220",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(!row.hasRunRecord) ? _c('div', {
          staticClass: "run-record-cell run-record-cell--empty"
        }, [_vm._v("\n            --\n          ")]) : _c('div', {
          staticClass: "run-record-cell"
        }, [_c('div', {
          staticClass: "run-record-line"
        }, [_vm._v(_vm._s(row.runRecordLine1))]), _vm._v(" "), _c('div', {
          staticClass: "run-record-line"
        }, [_vm._v(_vm._s(row.runRecordLine2))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publishedAt",
      "label": "发布时间",
      "min-width": "175",
      "align": "center",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.publishedAtText))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shareCount",
      "label": "分享次数",
      "min-width": "125",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "likeCount",
      "label": "点赞数",
      "min-width": "125",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "commentCount",
      "label": "评论数",
      "min-width": "125",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "viewCount",
      "label": "浏览量",
      "min-width": "125",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusText",
      "label": "审核状态",
      "min-width": "95",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "驳回原因",
      "min-width": "140",
      "align": "center",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.auditReasonDisplay))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isHandpickText",
      "label": "是否精选",
      "min-width": "85",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否置顶",
      "min-width": "190",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.isPinned === 1) ? _c('div', {
          staticClass: "pin-time-cell"
        }, [_c('div', [_vm._v("是")]), _vm._v(" "), _c('div', {
          staticClass: "pin-time-line"
        }, [_vm._v("\n              " + _vm._s(row.pinStartTimeText || "--") + "\n            ")]), _vm._v(" "), (row.pinEndTimeText) ? _c('div', {
          staticClass: "pin-time-line"
        }, [_vm._v("\n              至 " + _vm._s(row.pinEndTimeText) + "\n            ")]) : _vm._e()]) : _c('span', [_vm._v("否")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "240",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openSingleAudit(row)
            }
          }
        }, [_vm._v("审核")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openSingleHandpick(row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(Number(row.isHandpick) === 1 ? "取消精选" : "精选") + "\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openPinDialog(row)
            }
          }
        }, [_vm._v("\n            " + _vm._s(Number(row.isPinned) === 1 ? "取消置顶" : "置顶") + "\n          ")]), _vm._v(" "), (_vm.isDynamicApproved(row)) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openCommentDialog(row)
            }
          }
        }, [_vm._v("评论")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('div', {
    staticClass: "bottom-action-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedRows.length === 0
    },
    on: {
      "click": _vm.openBatchAuditDialog
    }
  }, [_vm._v("批量审核")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedRows.length === 0
    },
    on: {
      "click": _vm.openBatchHandpickDialog
    }
  }, [_vm._v("精选")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total > 0"
    }],
    staticClass: "pagination-seq"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, next",
      "current-page": _vm.queryParam.pageNum,
      "page-size": _vm.queryParam.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changeCurrentPage
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pagination-seq-hint"
  }, [_vm._v("第 " + _vm._s(_vm.queryParam.pageNum) + " 页")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "动态审核",
      "size": "tiny",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.auditDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.auditDialog, "visible", $$v)
      },
      expression: "auditDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    on: {
      "change": _vm.onAuditDialogStatusChange
    },
    model: {
      value: (_vm.auditDialog.auditStatus),
      callback: function($$v) {
        _vm.$set(_vm.auditDialog, "auditStatus", $$v)
      },
      expression: "auditDialog.auditStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "通过",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "不通过",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), (_vm.auditDialog.auditStatus === 2) ? _c('el-form-item', {
    staticClass: "audit-reject-form-item",
    attrs: {
      "label": "驳回原因"
    }
  }, [_c('div', {
    staticClass: "audit-reject-block"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择事由类型（可选）"
    },
    on: {
      "change": _vm.onAuditRejectReasonKeyChange
    },
    model: {
      value: (_vm.auditDialog.rejectReasonKey),
      callback: function($$v) {
        _vm.$set(_vm.auditDialog, "rejectReasonKey", $$v)
      },
      expression: "auditDialog.rejectReasonKey"
    }
  }, _vm._l((_vm.auditRejectReasonOptions), function(opt) {
    return _c('el-option', {
      key: opt.key,
      attrs: {
        "label": opt.label,
        "value": opt.key
      }
    })
  }), 1), _vm._v(" "), (_vm.auditDialog.rejectReasonKey === _vm.auditRejectReasonOtherKey) ? _c('el-input', {
    staticClass: "reject-extra-input",
    attrs: {
      "type": "textarea",
      "rows": 2,
      "maxlength": 50,
      "placeholder": "请输入驳回原因（选填，最多50字）",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.auditDialog.rejectReasonExtra),
      callback: function($$v) {
        _vm.$set(_vm.auditDialog, "rejectReasonExtra", $$v)
      },
      expression: "auditDialog.rejectReasonExtra"
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.auditDialog.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitBatchAudit
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看图片",
      "size": "large",
      "modal-append-to-body": false,
      "custom-class": "dynamic-image-preview-dialog"
    },
    on: {
      "close": _vm.closeImagePreview
    },
    model: {
      value: (_vm.imagePreview.visible),
      callback: function($$v) {
        _vm.$set(_vm.imagePreview, "visible", $$v)
      },
      expression: "imagePreview.visible"
    }
  }, [(_vm.imagePreview.urls.length > 1) ? _c('div', {
    staticClass: "image-preview-toolbar"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        return _vm.shiftImagePreview(-1)
      }
    }
  }, [_vm._v("上一张")]), _vm._v(" "), _c('span', {
    staticClass: "image-preview-counter"
  }, [_vm._v(_vm._s(_vm.imagePreview.index + 1) + " / " + _vm._s(_vm.imagePreview.urls.length))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-arrow-right"
    },
    on: {
      "click": function($event) {
        return _vm.shiftImagePreview(1)
      }
    }
  }, [_vm._v("下一张")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "image-preview-body"
  }, [(_vm.imagePreview.urls.length) ? _c('img', {
    staticClass: "image-preview-img",
    attrs: {
      "src": _vm.imagePreview.urls[_vm.imagePreview.index],
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeImagePreview
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "播放视频",
      "size": "large",
      "modal-append-to-body": false,
      "custom-class": "dynamic-video-preview-dialog"
    },
    on: {
      "close": _vm.closeVideoPreview
    },
    model: {
      value: (_vm.videoPreview.visible),
      callback: function($$v) {
        _vm.$set(_vm.videoPreview, "visible", $$v)
      },
      expression: "videoPreview.visible"
    }
  }, [(_vm.videoPreview.url) ? _c('video', {
    ref: "previewVideo",
    staticClass: "video-preview-player",
    attrs: {
      "src": _vm.videoPreview.url,
      "poster": _vm.videoPreview.poster || undefined,
      "controls": "",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeVideoPreview
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "精选",
      "size": "tiny",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.handpickDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.handpickDialog, "visible", $$v)
      },
      expression: "handpickDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否精选"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    model: {
      value: (_vm.handpickDialog.isHandpick),
      callback: function($$v) {
        _vm.$set(_vm.handpickDialog, "isHandpick", $$v)
      },
      expression: "handpickDialog.isHandpick"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "是",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": 0
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-tip"
  }, [_vm._v("精选后，符合条件的用户可能在首页看到该动态")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.handpickDialog.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitBatchHandpick
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "置顶",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.pinDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.pinDialog, "visible", $$v)
      },
      expression: "pinDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否置顶"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    model: {
      value: (_vm.pinDialog.isPin),
      callback: function($$v) {
        _vm.$set(_vm.pinDialog, "isPin", $$v)
      },
      expression: "pinDialog.isPin"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "是",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": 0
    }
  })], 1)], 1), _vm._v(" "), (_vm.pinDialog.isPin === 1) ? _c('el-form-item', {
    attrs: {
      "label": "置顶时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "380px"
    },
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "placeholder": "请选择开始时间至结束时间"
    },
    model: {
      value: (_vm.pinDialog.pinTime),
      callback: function($$v) {
        _vm.$set(_vm.pinDialog, "pinTime", $$v)
      },
      expression: "pinDialog.pinTime"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-tip"
  }, [_vm._v("置顶后，该动态将在APP推荐页的第一个坑位")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pinDialog.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.pinSubmitting
    },
    on: {
      "click": _vm.submitPin
    }
  }, [_vm._v("确认")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "评论动态",
      "size": "small",
      "modal-append-to-body": false,
      "custom-class": "dynamic-comment-dialog"
    },
    on: {
      "close": _vm.onCommentDialogClose
    },
    model: {
      value: (_vm.commentDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.commentDialog, "visible", $$v)
      },
      expression: "commentDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "82px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评论账号"
    }
  }, [_c('div', {
    staticClass: "form-item-row"
  }, [_c('div', {
    staticClass: "form-item-row__col form-item-row__col--author"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": _vm.onCommentAuthorTypeChange
    },
    model: {
      value: (_vm.commentDialog.publishAuthorType),
      callback: function($$v) {
        _vm.$set(_vm.commentDialog, "publishAuthorType", $$v)
      },
      expression: "commentDialog.publishAuthorType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "马甲号",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "官号",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "校园主理人",
      "value": 4
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-row__col form-item-row__col--mode"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": _vm.onCommentAccountSearchModeChange
    },
    model: {
      value: (_vm.commentAccountSearchMode),
      callback: function($$v) {
        _vm.commentAccountSearchMode = $$v
      },
      expression: "commentAccountSearchMode"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "昵称",
      "value": "name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "用户ID",
      "value": "uid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-row__col form-item-row__col--grow"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "remote": "",
      "placeholder": "选择用户ID或昵称",
      "loading": _vm.commentSelectLoading,
      "remote-method": _vm.queryCommentBurnerAccount
    },
    on: {
      "clear": _vm.onCommentAccountSelectClear
    },
    model: {
      value: (_vm.commentDialog.publishUid),
      callback: function($$v) {
        _vm.$set(_vm.commentDialog, "publishUid", $$v)
      },
      expression: "commentDialog.publishUid"
    }
  }, _vm._l((_vm.commentAccountOptions), function(item) {
    return _c('el-option', {
      key: item.uid,
      attrs: {
        "label": item.nickName,
        "value": item.uid
      }
    }, [_c('div', {
      staticClass: "account-option"
    }, [(item.headImgUrl) ? _c('img', {
      staticClass: "account-option-avatar",
      attrs: {
        "src": item.headImgUrl,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.nickName) + "（ID: " + _vm._s(item.uid) + "）")])])])
  }), 1)], 1)])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评论内容"
    }
  }, [_c('el-input', {
    ref: "commentContentInput",
    attrs: {
      "type": "textarea",
      "rows": 4,
      "maxlength": 500,
      "placeholder": "请输入",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.commentDialog.content),
      callback: function($$v) {
        _vm.$set(_vm.commentDialog, "content", $$v)
      },
      expression: "commentDialog.content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comment-emoji-bar"
  }, [_c('el-button', {
    staticClass: "comment-emoji-trigger",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.commentEmojiPanelVisible = !_vm.commentEmojiPanelVisible
      }
    }
  }, [_c('span', {
    staticClass: "comment-emoji-trigger-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("☺")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.commentEmojiPanelVisible),
      expression: "commentEmojiPanelVisible"
    }],
    staticClass: "comment-emoji-panel"
  }, _vm._l((_vm.commentEmojiList), function(emoji, index) {
    return _c('span', {
      key: index,
      staticClass: "comment-emoji-item",
      on: {
        "click": function($event) {
          return _vm.insertCommentEmoji(emoji)
        }
      }
    }, [_vm._v(_vm._s(emoji))])
  }), 0)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.commentDialog.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.commentSubmitting
    },
    on: {
      "click": _vm.submitComment
    }
  }, [_vm._v("确认")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41557401!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/Dynamics/DynamicManage/DynamicManage.vue
// module id = 1003
// module chunks = 0